import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyTypeTrackerService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CompanyTypeTracker');
	}

    loadAll(): Observable<ePM.Logic.CompanyTypeTracker[]> {
		return this.myBaseService.loadAll(this.url);
	}
	add(id: System.Guid): Observable<ePM.Logic.CompanyTypeTracker> {
		return this.myBaseService.save(null, this.url + '/' + id);
	}
	delete(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
}
				